// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"28feb60c","388":"7a546f3d","465":"73260706"}[chunkId] + ".chunk.css";
};